import * as Scrivito from "scrivito"

export function getCurrentSiteID() {
  return Scrivito.currentSiteId() || "de"
}
